import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import isEmpty from 'lodash/isEmpty';

// Components
// import TTTable from "./TTTable";
import Loader from "../../../utils/Loader";

class DataSearchTable extends Component{
    constructor(props){
        super(props);

		this.state = {
            loading: false,
            currentPage: 1,
            leftIndex: 0,
            rightIndex: 0,
            q: '',
            dataSearched: []
		};
    }

    componentDidMount(){
        //Right index initialization
        this.setState({
            rightIndex: this.props.itemsPerPage,
            loading: false
        }, () => {
            if(!isEmpty(this.props.searchQuery)){
                this.setState({
                    q: this.props.searchQuery
                }, () => this.handleSearch(this.props.searchQuery))
            }
        });
    }

    prevPage = () => {
        const rightIndex = this.state.leftIndex;
        const leftIndex = this.returnMinLeftIndex(this.state.leftIndex - this.props.itemsPerPage)

        this.setState({
            leftIndex: leftIndex,
            rightIndex: rightIndex,
            currentPage: this.state.currentPage === 1 ? 1 : this.state.currentPage - 1
        })
    }

    nextPage = () => {
        const leftIndex = this.state.rightIndex;
        const rightIndex = this.returnMaxRightIndex(leftIndex + this.props.itemsPerPage);

        this.setState({
            leftIndex: leftIndex,
            rightIndex: rightIndex,
            currentPage: this.state.currentPage + 1
        })
    }

    // Gets the highest right index (based on the max length of array)
    returnMaxRightIndex = (testIndex) => {
        return testIndex > this.props.data.length ? this.props.data.length : testIndex;
    }

    // Gets the lowest index, forcing 0 to be the minimum
    returnMinLeftIndex = (testIndex) => {
        return testIndex < 0 ? 0 : testIndex;
    }

    searchFilter = (item, value) => {
        let found = false;

        this.props.searchProperties.forEach(element => {
            if(!found)
                found = !!item[element] && item[element].toLowerCase().includes(value.toLowerCase());
        });
        return found;
    }

    handleSearch(value){
        this.props.storeSearch(value);

        this.setState({
            isSearching: true,
            q: value,
            currentPage: 1,
            leftIndex: 0,
            rightIndex: this.returnMaxRightIndex(0 + this.props.itemsPerPage)
        }, () => {
            if(isEmpty(value)){
                this.setState({
                    isSearching: false
                });
            } else {
                this.setState({ 
                    dataSearched: this.props.data.filter(item => this.searchFilter(item, value) )
                })
            }
        })
    }
    
    render(){
        const { type, data, notification, format } = this.props;
        const { loading, currentPage, leftIndex, rightIndex, q, isSearching, dataSearched } = this.state;
        let tableData = isSearching ? dataSearched : data;
        const lastPage = Math.floor((tableData.length - 1) / 10 + 1);

        return (
            <Fragment>
                {loading ? 
                <div className="pt2 pb2">
                    <Loader />
                </div> :
                <Fragment>
                    {/* Searchbar */}
                    <div className="ajax-search-wrapper tt-searchbar">
                        <div className={`input-placeholder-wrapper placeholder--search-field`}>
                            <span className="placeholder icon-search" />
                            <input type="text" value={q} placeholder={"Search " + type} onChange={e => this.handleSearch(e.target.value)}/>
                        </div>
                    </div>

                    {/* Pagination */}
                    <div className="customer-search-items-pagination assigned-products">
                        <button disabled={currentPage === 1} onClick={() => this.prevPage()}> 
                            <div className="icon-backward"></div>
                            Prev
                        </button>
                        <div className="customer-search-items-pagination-page">{currentPage + ' - ' + (lastPage === 0 ? '1' : lastPage)}</div>
                        <button disabled={rightIndex >= tableData.length} onClick={() => this.nextPage()}>
                            Next
                            <div className="icon-forward"></div>
                        </button>
                    </div>

                    {/* Data Table */}
                    <table className="display_table">
                        <thead>
                            <tr className="table-header">
                                {this.props.showRowNumbers && <th>#</th>}

                                {format.map((item, i) => {
                                    return (
                                        <th key={i}>{item.header}</th>
                                    )
                                })}

                                {!!this.props.clickActionText && <th></th>}
                            </tr>
                        </thead>
                        <tbody>
                            {!!tableData && tableData.length <= 0 && isEmpty(q) && <tr><td/><td colSpan="3">{notification}</td></tr>}
                            {!!tableData && tableData.length <= 0 && !isEmpty(q) && <tr><td/><td colSpan="3">{'No results found.'}</td></tr>}
                            {!!tableData && tableData.length > 0 &&
                            !!tableData && tableData.slice(leftIndex, rightIndex).map((item, index) => {
                                return (
                                    <tr key={index} className={!!this.props.clickAction ? "clickable" : ""} onClick={!!this.props.clickAction ? () => this.props.clickAction(type, item) : null}>

                                        {/* Id Columm */}
                                        {this.props.showRowNumbers && <td>{index + 1}</td>}

                                        {/* Data */}
                                        {format.map((format, i) => {
                                            return (
                                                <td key={i}>{item[format.property] ? item[format.property] : ''}</td>
                                            )
                                        })}

                                        {/* Action Btn Text */}
                                        {!!this.props.clickActionText && <td className="edit-cell"><div className="edit_btn">{this.props.clickActionText}</div></td>}
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </Fragment>
                }
            </Fragment>
        )
    }
    
}

const mapStateToProps = (state) => {
    return {
        user: state.user.admin
    }
}

export default connect(mapStateToProps, {})(DataSearchTable);


// WEBPACK FOOTER //
// ./src/components/admin/top-tiers/customers/DataSearchTable.js